"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.InfoContainer = exports.CrossIcon = exports.InnerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const CrossIcon_1 = require("../../../../../assets/svg-components/CrossIcon");
const Container_1 = require("../../../../UI/Container");
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
exports.InnerContainer = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  margin-top: ${props => props.theme.constants.paddings.md}px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-top: ${props => props.theme.spacing.l3}px;
  }
  height: ${props => props.theme.constants.blockHeight.m7}px;
  box-shadow: ${props => `0px ${props.theme.spacing.s1}px ${props.theme.spacing.s4}px ${props.theme.spacing.s2}px rgba(0, 0, 0, 0.15)`};
  position: relative;
  background: ${props => props.theme.palette.BW_100};
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;
exports.CrossIcon = (0, styled_components_1.default)(CrossIcon_1.CrossIcon) `
  position: absolute;
  top: ${props => props.theme.spacing.s4}px;
  right: ${props => props.theme.spacing.s4}px;
  cursor: pointer;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    width: ${props => props.theme.spacing.s3}px;
    height: ${props => props.theme.spacing.s3}px;
  }
  &:hover {
    > path {
      fill: ${props => props.theme.palette.DARK_BLUE_100};
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    top: ${props => props.theme.spacing.s3}px;
    right: ${props => props.theme.spacing.s3}px;
  }
`;
exports.InfoContainer = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: 0 0 0 ${props => props.theme.spacing.m3}px;

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    padding: 0;
  }
`;
exports.Container = (0, styled_components_1.default)(Container_1.Container) `
  display: flex;
  justify-content: center;
`;
exports.default = {
    CrossIcon: exports.CrossIcon,
    InfoContainer: exports.InfoContainer,
    Container: exports.Container,
    InnerContainer: exports.InnerContainer
};
